/**
 * Temporary component until we have a design for the flow of adding a player
 */
import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

type ToastType = 'alert' | 'success';

interface ToastProps {
  message: string;
  type: ToastType;
  callback: () => void;
  duration?: number;
}

const slideInAnimation = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(120%);
  }
`;

const ToastContainer = styled.div<{ type: ToastType }>`
  position: fixed;
  z-index: 1000000000000;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ type }) => (type === 'alert' ? '#ff5555' : '#33cc33')};
  color: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: ${slideInAnimation} 0.3s ease-in-out forwards;
`;

const Toast: React.FC<ToastProps> = ({ message, type, callback, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      callback();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  return <ToastContainer type={type}>{message}</ToastContainer>;
};

export default Toast;
